import React from 'react'

const Benefit = () => (
  <section id="benefit" className="benefit">
    <div className="container">
      <h2 className="section-title">
        【来社特典】
      </h2>
      <div className="section-body">
        <div className="row">
          <div className="col s12 m6 offset-m3">
            <p>『志望動機、自己PRの作り方book』</p>
          </div>
        </div>
      </div>
    </div>    
  </section>
)

export default Benefit